

















import { Component, Vue } from 'vue-property-decorator';
import NavigationMenuComponent from './NavigationMenu.vue';
import UserComponent from './User.vue';

@Component({ components: { NavigationMenuComponent, UserComponent } })
export default class NavigationComponent extends Vue {
    menuIsHidden = true;

    toggleMenu($event: any): void {
        this.menuIsHidden = !this.menuIsHidden;
    }
}
